import { createSlice } from "@reduxjs/toolkit";

const screenTimeSlice = createSlice({
  name: "screenTimeSlice",
  initialState: {
    appActivityData: null,
    callSmsDetailData: null,
  },
  reducers: {
    setCallSmsData: (state, action) => {
      state.callSmsData = action?.payload;
    },
    setCallSmsDetailData: (state, action) => {
      state.callSmsDetailData = action?.payload;
    },
    clearLocation: (state, action) => {
      state.appActivityData = null;
      state.callSmsDetailData = null;
    },
  },
});

// this is for dispatch
export const { setCallSmsData, setCallSmsDetailData, clearLocation } =
  screenTimeSlice.actions;

// this is for configureStore
export default screenTimeSlice.reducer;
